import { useEffect, useState } from "react";
import {
  Box,
  Stack,
  Typography,
  IconButton,
  TextField,
  Avatar,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useQuery } from "@apollo/client";
import moment from "moment";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// Import from project
import "./dashboard.scss";
import { GET_STUDENT_PAID_AND_NOT_YET_GET_MATERIALS } from "../../Schema/Dashboard";
import { SelectAcademicYear } from "../Include/DynamicSelect";
import LoadingPage from "../Include/LoadingPage";
import EmptyData from "../Include/EmptyData";
// import ViewImage from "../../Academic/Student/ViewImage";

export default function CardNewStudent() {
  const [fromDate, setFromDate] = useState(new Date("2026-01-01"));
  const [toDate, setToDate] = useState(new Date());

  const academicYearFromLocal = JSON.parse(
    window.localStorage.getItem("academicYearFromLocal"),
  );
  const [academicYearVal, setAcademicYearVal] = useState(
    academicYearFromLocal ? academicYearFromLocal : { id: "", title: "" },
  );

  const { data, refetch, loading, error } = useQuery(
    GET_STUDENT_PAID_AND_NOT_YET_GET_MATERIALS,
    {
      variables: {
        academicYearId: academicYearVal?.id || null,
        fromDate: fromDate
          ? moment(fromDate).startOf("day").format("YYYY-MM-DD")
          : null,
        toDate: toDate ? moment(toDate).format("YYYY-MM-DD") : null,
      },
      // fetchPolicy: "network-only",
    },
  );

  if (error) {
    console.error("GraphQL Query Error: ", error);
  }

  useEffect(() => {
    refetch();
  }, []);

  const tableData = data?.getStudentPaidAndNotYetGetMaterials || [];
  // console.log("tableData::", tableData);

  return (
    <Box className="visitor-chart">
      <Stack direction="column" spacing={2}>
        <Stack direction="row" spacing={2} alignItems="center">
          <Typography className="chart-title">
            សិស្សមិនទាន់មានសម្ភារៈសិក្សា
          </Typography>
          <Box sx={{ width: "18%" }}>
            <SelectAcademicYear
              selectedVal={academicYearVal}
              setSelectedVal={setAcademicYearVal}
            />
          </Box>
          <Box sx={{ width: "18%" }}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                value={fromDate}
                onChange={(val) => setFromDate(val)}
                className="text-field-date"
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ width: "18%" }}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                value={toDate}
                onChange={(val) => setToDate(val)}
                className="text-field-date"
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            </LocalizationProvider>
          </Box>
        </Stack>

        <Stack spacing={1} sx={{ overflowY: "auto", height: 400 }}>
          {loading ? (
            <LoadingPage />
          ) : tableData.length === 0 ? (
            <EmptyData />
          ) : (
            tableData.map((e, index) => (
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                key={e?.studentId || index}
              >
                <Stack width="25%">
                  <Stack direction="row" spacing={1} className="student-info">
                    <Stack direction="column" justifyContent="center">
                      <Avatar
                        alt=""
                        src={
                          e?.profileImg?.slice(0, 5) === "https"
                            ? e?.profileImg
                            : `${process.env.REACT_APP_VIEW_URL}${e?.profileImg}`
                        }
                      />
                    </Stack>
                    <Stack direction="column" justifyContent="center">
                      <Typography className="student-name">
                        {`${e?.lastName || ""} ${e?.firstName || ""}`}
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>

                <Typography width="25%">{e?.classGrade}</Typography>

                <Typography width="40%">{e?.incomeHead}</Typography>

                <Typography width="10%">Invoice No: {e?.invoiceNo}</Typography>

                <Stack width="10%" direction="row" justifyContent="flex-end">
                  <IconButton sx={{ color: "#0f81c2" }}>
                    <ArrowForwardIosIcon fontSize="small" />
                  </IconButton>
                </Stack>
              </Stack>
            ))
          )}
        </Stack>
      </Stack>
    </Box>
  );
}
